import Component from "vue-class-component";
import ServiceCalendarProps from "./ServiceCalendarProps";
import AppointmentService from "@/api/Services/Appointment";
// eslint-ignore-next-line
import VCalendar from "v-calendar/lib/components/calendar.umd";
import moment from "moment";
import { bus } from "@/main";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import { mapGetters } from "vuex";

const todayHightlight = {
  key: "today",
  highlight: {
    style: {
      backgroundColor: "#FFB800",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(242, 202, 0, 0.3)",
    },
    fillMode: "solid",
  },
  dates: new Date(),
};

const locale = {
  id: "pt-BR",
  firstDayOfWeek: 1,
  masks: {
    title: "MMMM YYYY",
    weekdays: "W",
  },
};

@Component({
  name: "ServiceCalendarComponent",

  components: {
    VCalendar,
  },
  computed: mapGetters(["getDate", "getClinicId"]),
})
export default class ServiceCalendarComponent extends ServiceCalendarProps {
  getDate!: string;
  getClinicId!: string;

  attrs: any[] = [todayHightlight];
  cx_locale: any = locale;
  selectedDate: any = null;
  cx_disabled_dates: any = [];
  cx_current_date: any = new Date();

  constructor() {
    super();
  }

  mounted() {
    if (this.getDate) {
      const dateFormated = new Date(this.getDate);
      this.onDayClick(dateFormated);
    }
  }

  onDayClick(day: any): void {
    if (day.id) {
      this.selectedDate = day.date;
    } else {
      this.selectedDate = day;
    }

    const todayLocaleDate = moment(new Date()).format("YYYY-MM-DD");
    const selectedDateLocaleDate = moment(this.selectedDate).format("YYYY-MM-DD");

    let colorDate = "";

    if (selectedDateLocaleDate >= todayLocaleDate && !day.isDisabled) {
      if (this.$route.name === "SearchServicesTenancy" || this.$route.name === "ClinicScreen") {
        colorDate = "#005B8F";
      } else {
        colorDate = "#00B1AC";
      }
    } else {
      this.selectedDate = "";
    }

    const selectedHighlight = {
      key: "selected",
      highlight: {
        style: {
          backgroundColor: colorDate,
          borderRadius: "8px",
          borderShadow: "0px 4px 10px rgba(0, 177, 172, 0.7)",
        },
        fillMode: "solid",
      },
      dates: this.selectedDate,
    };

    if (todayLocaleDate !== selectedDateLocaleDate)
      this.attrs = [todayHightlight, selectedHighlight];
    else this.attrs = [selectedHighlight];

    this.$store.commit("setDate", this.selectedDate.toString());
    this.$emit("disableNext");
  }

  monthChange(page: any) {
    bus.$emit("showLoadingSideModal", true);
    page.month--;
    this.cx_disabled_dates = [];
    const startDate = moment(page).format("YYYY-MM-DD");
    const endDate = moment(page).endOf("month").format("YYYY-MM-DD");

    AppointmentService.getHoursAvailableInterval(this.getClinicId, startDate, endDate)
      .then((response: any) => {
        const responseData = response.data as ResponseInterface;
        const dates = responseData.data;

        dates.forEach((date: any) => {
          if (!date.available) {
            const tmpDate = date.date;
            this.cx_disabled_dates.push({
              start: new Date(`${tmpDate}T00:00:01`),
              end: new Date(`${tmpDate}T23:59:59`),
            });
          }
        });
      })
      .finally(() => {
        bus.$emit("showLoadingSideModal", false);
      });
  }
}
